import AbstractApiReducer from "services/cores/abstractApiReducer";
import AvailableParkingActionTypes from "./types";

const instance = new AbstractApiReducer(AvailableParkingActionTypes, {
  list: {
    orders: {},
  },
});
export default instance.reducer;
